module.exports = __webpack_public_path__ + "img/mira_909l_list.6c252931.jpg";